module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/139-venezuela-e6476a372795d0bac7db543f0a6d7d24.svg";